<template>
  <el-dialog title="关联提货订单" :visible="visible" width="900px" @close="handleClose">
    <div class="select-order-container">
      <el-form :inline="true" class="search-form">
        <el-form-item label="提货编号">
          <el-input v-model="pickupNumber" placeholder="请输入提货编号" clearable @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">搜索</el-button>
        </el-form-item>
        <!-- 新增选中数量合计行 -->
        <el-form-item>
          <span>已选实提总量：<b>{{ totalPickupQty }}</b></span>
        </el-form-item>
      </el-form>

      <el-table
        ref="multipleTable"
        :data="recordList"
        border
        class="record-table"
        max-height="380"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" :selectable="isRowSelectable"></el-table-column>
        <el-table-column label="提货编号" prop="pickupNumber"></el-table-column>
        <el-table-column label="品种规格" prop="specName"></el-table-column>
        <el-table-column label="车牌号" prop="vehicleKey"></el-table-column>
        <!-- 选择提货单时同时展示司机姓名，便于核对车辆。 -->
        <el-table-column label="司机姓名" prop="driverName"></el-table-column>
        <!-- 实提数量使用损耗承担方对应的结算量，发货和到货原始字段保持独立。 -->
        <el-table-column label="实提数量" prop="settlementQuantity"></el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="onSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'LinkOrderChoose',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    selectIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      recordList: [],
      pickupNumber: '',
      selectedList: [] // 存储当前表格选中行
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user
    },
    // 按损耗承担方对应的实提数量汇总选中记录。
    totalPickupQty() {
      const total = this.selectedList.reduce((sum, item) => {
        return sum + Number(item.settlementQuantity || 0)
      }, 0)
      return Number(total.toFixed(3))
    }
  },
  watch: {
    visible(val) {
      if (val) {
        console.log('selected', this.selectIds)
        this.getList()
      } else {
        // 弹窗关闭清空选中缓存
        this.selectedList = []
      }
    }
  },
  methods: {
    // 已经关联其他点价单的提货记录不再允许重复选择；当前单已选记录仍可正常回显。
    isRowSelectable(row) {
      return this.selectIds.includes(row.pickupId) || row.ycState !== '2'
    },
    // 表格选中变动回调
    handleSelectionChange(rows) {
      this.selectedList = rows
    },
    onSearch() {
      this.getList()
    },
    onSubmit() {
      const selectData = this.selectedList
      if (selectData && selectData.length > 0) {
        this.$emit('confirm', selectData)
        this.handleClose()
      } else {
        this.$message.error('请选择关联提货订单')
      }
    },
    handleClose() {
      this.$emit('close')
    },
    getList() {
      this.$axios
        .get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPageV2, {
          pickupNumber: this.pickupNumber,
          orderId: this.orderId,
          pickupStatus: '3',
          orderType: '2'
        })
        .then(res => {
          if (res) {
            const selectList = []
            // 供应商承担取到货量，采购方及历史空值取发货量；零数量不回退为其他数量。
            this.recordList = (res.list || []).map(item => ({
              ...item,
              settlementQuantity: (item.lossBearer === '2' ? item.arrivalQuantity : item.pickupQuantity) ?? 0 // 可关联实提数量
            }))
            this.recordList.forEach(item => {
              const isSelected = this.selectIds.includes(item.pickupId)
              if (isSelected) {
                selectList.push(item)
              }
            })
            this.$nextTick(() => {
              if (this.$refs.multipleTable) {
                // 先清空旧选中
                this.$refs.multipleTable.clearSelection()
                if (selectList.length) {
                  selectList.forEach(item => {
                    this.$refs.multipleTable.toggleRowSelection(item, true)
                  })
                  // 回显时同步赋值选中列表
                  this.selectedList = selectList
                } else {
                  this.selectedList = []
                }
              }
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-order-container {
  max-height: 500px;
  overflow-y: auto;
}

.search-form {
  margin-bottom: 20px;
}

.record-table {
  margin-bottom: 10px;
}

.total-row {
  padding: 8px 0;
  font-size: 14px;
  color: #333;
  b {
    color: var(--el-color-primary);
  }
}

.dialog-footer {
  text-align: right;
}
</style>
